var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment, } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import ActionDelete from '@material-ui/icons/Delete';
import classnames from 'classnames';
import inflection from 'inflection';
import { useTranslate, useDeleteWithConfirmController, useResourceContext, } from 'ra-core';
import Confirm from '../layout/Confirm';
import Button from './Button';
var DeleteWithConfirmButton = function (props) {
    var basePath = props.basePath, classesOverride = props.classes, className = props.className, _a = props.confirmTitle, confirmTitle = _a === void 0 ? 'ra.message.delete_title' : _a, _b = props.confirmContent, confirmContent = _b === void 0 ? 'ra.message.delete_content' : _b, _c = props.icon, icon = _c === void 0 ? defaultIcon : _c, _d = props.label, label = _d === void 0 ? 'ra.action.delete' : _d, mutationMode = props.mutationMode, onClick = props.onClick, record = props.record, _e = props.redirect, redirect = _e === void 0 ? 'list' : _e, onSuccess = props.onSuccess, onFailure = props.onFailure, rest = __rest(props, ["basePath", "classes", "className", "confirmTitle", "confirmContent", "icon", "label", "mutationMode", "onClick", "record", "redirect", "onSuccess", "onFailure"]);
    var translate = useTranslate();
    var classes = useStyles(props);
    var resource = useResourceContext(props);
    var _f = useDeleteWithConfirmController({
        record: record,
        redirect: redirect,
        basePath: basePath,
        mutationMode: mutationMode,
        onClick: onClick,
        onSuccess: onSuccess,
        onFailure: onFailure,
        resource: resource,
    }), open = _f.open, loading = _f.loading, handleDialogOpen = _f.handleDialogOpen, handleDialogClose = _f.handleDialogClose, handleDelete = _f.handleDelete;
    return (React.createElement(Fragment, null,
        React.createElement(Button, __assign({ onClick: handleDialogOpen, label: label, className: classnames('ra-delete-button', classes.deleteButton, className), key: "button" }, rest), icon),
        React.createElement(Confirm, { isOpen: open, loading: loading, title: confirmTitle, content: confirmContent, translateOptions: {
                name: translate("resources." + resource + ".forcedCaseName", {
                    smart_count: 1,
                    _: inflection.humanize(translate("resources." + resource + ".name", {
                        smart_count: 1,
                        _: inflection.singularize(resource),
                    }), true),
                }),
                id: record.id,
            }, onConfirm: handleDelete, onClose: handleDialogClose })));
};
var defaultIcon = React.createElement(ActionDelete, null);
var useStyles = makeStyles(function (theme) { return ({
    deleteButton: {
        color: theme.palette.error.main,
        '&:hover': {
            backgroundColor: fade(theme.palette.error.main, 0.12),
            // Reset on mouse devices
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
    },
}); }, { name: 'RaDeleteWithConfirmButton' });
DeleteWithConfirmButton.propTypes = {
    basePath: PropTypes.string,
    classes: PropTypes.object,
    className: PropTypes.string,
    confirmTitle: PropTypes.string,
    confirmContent: PropTypes.string,
    label: PropTypes.string,
    record: PropTypes.any,
    redirect: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
        PropTypes.func,
    ]),
    resource: PropTypes.string,
    icon: PropTypes.element,
};
export default DeleteWithConfirmButton;
